export const APPLY = 'APPLY';
export const APPLY_PENDING = 'APPLY_PENDING';
export const APPLY_FAILURE = 'APPLY_FAILURE';
export const APPLY_SUCCESS = 'APPLY_SUCCESS';
export const CLEAR_APPLICATION = 'CLEAR_APPLICATION';
export const VENDOR_CONFIG = 'VENDOR_CONFIG';
export const VENDOR_CONFIG_PENDING = 'VENDOR_CONFIG_PENDING';
export const VENDOR_CONFIG_FAILURE = 'VENDOR_CONFIG_FAILURE';
export const VENDOR_CONFIG_SUCCESS = 'VENDOR_CONFIG_SUCCESS';
